/* import __COLOCATED_TEMPLATE__ from './vertical-unpaired-device-icon.hbs.js'; */
var _dec, _dec2, _class, _descriptor;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { computed } from '@ember/object';
import { readOnly } from '@ember/object/computed';
import SvgIcon from '@square/glass-ui/components/svg/svg-icon';
import { getVerticalColor } from '@dashboard/shared-ui/utils/verticals';

/**
##Svgs::Devices::VerticalUnpairedDeviceIcon

Displays an SVG of the unpaired devices icon with a vertical theme

### Params
@param {String} vertical - The vertical that is using the unpaired device icon. This configures the Square jewel color.
                           Verticals are defined in @dashboard/shared-ui/utils/vertical-configs.

### Example usage
hbs```
  <Svgs::Devices::VerticalUnpairedDeviceIcon @vertical={{Vertical.RESTAURANTS}} />
```
 */
let VerticalUnpairedDeviceIcon = (_dec = readOnly('vertical'), _dec2 = computed('vertical'), (_class = class VerticalUnpairedDeviceIcon extends SvgIcon {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "width", 56);
    _defineProperty(this, "height", 50);
    _defineProperty(this, "viewBox", '0 0 56 50');
    _defineProperty(this, "fill", 'none');
    _initializerDefineProperty(this, 'data-test-svgs-devices-vertical-unpaired-device-icon', _descriptor, this);
    // Inherited from SvgIcon base class, this adds a class that interferes with
    // SVG styling
    _defineProperty(this, "colorClass", null);
  }
  get defaultColor() {
    return getVerticalColor(this.vertical);
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'data-test-svgs-devices-vertical-unpaired-device-icon', [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "defaultColor", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "defaultColor"), _class.prototype)), _class));
export { VerticalUnpairedDeviceIcon as default };